import Router from 'next/router';
import segmentStorage from '@events/segmentStorage';

const scollToTop = () => document.documentElement.scrollTo(0, 0);

const pushRoute = (url, as, options, lps, replace = false) => {
  if (lps) {
    segmentStorage.setItem('lps', lps);
  }
  const routeOptions = options || {};
  if (replace) {
    return Router.replace(url, as, routeOptions).then(scollToTop);
  }

  return Router.push(url, as, routeOptions).then(scollToTop);
};

export default pushRoute;
